// routes
import Router from './routes';
import ThemeProvider from './theme';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import NotistackProvider from './components/notistack/NotistackProvider';
import './i18n';
import "iranianbanklogos/dist/ibl.css";
import './components/map/styles.css';
import {configAxios} from "./utils/axios";
import useAuth from "./hooks/useAuth";
import 'leaflet/dist/leaflet.css';
import Permission from "./components/permission/Permission";


export default function App() {
  const {logout} = useAuth()
  configAxios(logout)

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <Permission />
              <ProgressBarStyle />
              {/* <Settings /> */}
              <ScrollToTop />
              <Router />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
